import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import raf from 'raf';
import { Event } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Pic from './pic';
import PicTxt from './picTxt';
import { handleAd } from '@ifeng-fe/ui_pc_ad';

const slideWidth = 200;

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        bannerAd: PropTypes.object,
        txtShow: PropTypes.bool,
        handleTxtShow: PropTypes.func,
    };

    state = {
        initLeft: 0,
        left: 0,
        current: 0,
        translateY: 72,
        adBottom: 0,
        pageRight: -19,
        changeFlag: false,
    };

    event = new Event();

    box = React.createRef();
    swiperContainer = React.createRef();

    async componentDidMount() {
        this.swiperContainer.current.addEventListener('touchmove', this.handleTouchMove, false);
        window.location.hash = `#imgnum=${this.state.current + 1}`;

        try {
            const { bannerAd } = this.props;

            const callback = await handleAd(bannerAd);

            callback(this.box.current, bannerAd.data, this.event);
        } catch (e) {
            console.error(e);
        }

        try {
            const { current } = this.state;
            const {
                content: {
                    contentData: { image },
                },
            } = this.props;

            this.event.trigger('change', { current: current + 1, total: image.length });
        } catch (e) {
            console.error(e);
        }
    }

    componentWillUnmount() {
        this.swiperContainer.current.removeEventListener('touchmove', this.handleTouchMove);
    }

    componentDidUpdate(prevProps) {
        if (this.props.txtShow !== prevProps.txtShow) {
            if (this.props.txtShow) {
                this.upSlide();
            } else {
                this.downSlide();
            }
        }
    }

    upSlide = () => {
        let { translateY, adBottom, pageRight } = this.state;

        const step = () => {
            translateY -= 4;
            adBottom -= 10;
            pageRight -= 2;

            this.setState({
                translateY,
                adBottom,
                pageRight,
            });

            if (translateY <= 72) {
                raf.cancel(step);

                this.setState({
                    translateY: 72,
                    adBottom: 0,
                    pageRight: -11,
                });
            } else {
                raf(step);
            }
        };

        raf(step);
    };

    downSlide = () => {
        let { translateY, adBottom, pageRight } = this.state;

        const step = () => {
            translateY += 6;
            adBottom += 10;
            pageRight += 2;

            this.setState({
                translateY,
                adBottom,
                pageRight,
            });

            if (translateY >= 100) {
                raf.cancel(step);

                this.setState({
                    translateY: 100,
                    adBottom: 120,
                    pageRight: 3,
                });
            } else {
                raf(step);
            }
        };

        raf(step);
    };

    handleTouchStart = e => {
        const {
            content: {
                contentData: { image },
            },
        } = this.props;

        if (image.length === 1) return;

        const touch = e.touches[0];

        this.startX = touch.pageX;
        this.moveX = 0;
    };

    handleTouchMove = e => {
        e.preventDefault();
        const {
            content: {
                contentData: { image },
            },
        } = this.props;

        if (image.length === 1) return;

        const touch = e.touches[0];

        this.moveX = touch.pageX - this.startX;

        this.setState({
            changeFlag: Math.abs(this.moveX) > slideWidth,
        });
    };

    handleTouchEnd = () => {
        if (!this.moveX || this.moveX === 0) return;

        const { current } = this.state;
        const {
            content: {
                contentData: { image },
                preSlide,
                nextSlide,
            },
        } = this.props;

        if (image.length === 1) return;

        if (this.moveX >= slideWidth && current === 0 && preSlide) {
            window.location.href = preSlide.url;
        } else if (this.moveX < -slideWidth && current === image.length - 1 && nextSlide) {
            window.location.href = nextSlide.url;
        }
    };

    sendStaRequestByJs = () => {
        if (window.sendStaRequestByJs) {
            const { current } = this.state;
            const {
                content: {
                    contentData: { image },
                },
            } = this.props;
            const currentPageUrl = window.location.href; // 给统计传referer需要
            const urlStart = currentPageUrl.split('imgnum=')[0];

            history.replaceState(null, 'url', `${urlStart}imgnum=${current + 1}`);

            let param = null;
            const ref = currentPageUrl || document.referrer || '';
            const _h = window.location.href.split('#');
            const _k = _h[0].indexOf('?') > -1 ? '' : '?';
            const suffix = _h[0] + (window.location.search ? '&' : _k);

            const url = [
                `${suffix}srctag=zbs_slide_tj1#imgnum=${current + 1}`,
                `${suffix}srctag=zbs_slide_tj2#imgnum=${current + 1}`,
            ];

            if (current === image.length - 1) {
                param = url[1];
            } else {
                param = window.location.href;
            }

            window.sendStaRequestByJs({
                imgnum: current + 1,
                ref,
                url: param,
            });
        }
    };

    handleCurrentIndexChange = index => {
        const {
            content: {
                contentData: { image },
            },
        } = this.props;

        this.setState({
            current: index,
        });

        try {
            this.event.trigger('change', { current: index + 1, total: image.length });

            history.replaceState(null, document.title, `${window.location.href.split('#')[0]}#imgnum=${index + 1}`);
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { current, adBottom, pageRight } = this.state;
        const {
            content: {
                contentData: { image },
                fhhAccountDetail,
                source,
                title,
                subscribe,
            },
            txtShow,
            handleTxtShow,
        } = this.props;

        const data = {
            current,
            title,
            image,
        };

        return (
            <div className={styles.slide_box}>
                <div className={styles.pic_page} style={{ right: `${pageRight}%` }}>
                    <span className={styles.current}>{current + 1}</span>
                    <span className={styles.line}>/</span>
                    <span className={styles.total}>{image.length}</span>
                </div>
                <div className={styles.wemedia_box}>
                    {fhhAccountDetail.logo !== '' ? (
                        <div
                            style={{
                                backgroundImage: `url(${fhhAccountDetail.logo})`,
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                            }}
                        />
                    ) : (
                        ''
                    )}
                    <span>{fhhAccountDetail.weMediaName || source}</span>
                    <span>&nbsp;&nbsp;{subscribe.lastArticleAddress}</span>
                </div>
                <div className={styles.slide_list}>
                    <div
                        ref={this.swiperContainer}
                        onTouchStart={this.handleTouchStart}
                        onTouchCancel={this.handleTouchEnd}
                        onTouchEnd={this.handleTouchEnd}>
                        <Pic
                            content={image}
                            handleCurrentIndexChange={this.handleCurrentIndexChange}
                            handleTxtShow={handleTxtShow}
                        />
                    </div>
                </div>
                <PicTxt txtShow={txtShow} content={data} />
                <div className={styles.box} style={{ bottom: `-${adBottom}px` }} ref={this.box} />
            </div>
        );
    }
}

export default errorBoundary(Content);
